import React, { Fragment } from 'react'
import EmployeeCard, { IEmployee } from 'components/EmployeeCard'
import Carousel from 'components/Carousel'
import styles from './OwnersSection.scss'

// const ownerStub = {
//   ownerName: 'Urrutia Bilbao Oier Edorta',
//   ownerPhoto:
//     'https://media-exp1.licdn.com/dms/image/C4D03AQF_g76nHxOmPA/profile-displayphoto-shrink_400_400/0?e=1611187200&v=beta&t=SCFvF1E4Bd_83RAAe92d_tCdoUcJ8SLZPb9XX-fHoKM',
//   profileUrl: ['https://www.linkedin.com/in/oier-urrutia-58105918/']
// };
//
// const anotherOwnerStub = {
//   ownerName: 'Marissa sauer',
//   ownerPhoto: 'https://static.wixstatic.com/media/f26672_3e7ee0c491df41c3a7db52e1a0e18c4e~mv2.gif',
//   profileUrl: [
//     'https://www.linkedin.com/in/marissa-sauer-947651a/',
//     'https://www.facebook.com/marissa.sauer.7',
//     'https://www.instagram.com/marissa.sauer.7'
//   ],
//   ownerEmail: 'marissa.sauer@gmail.com',
//   location: 'Bilbao Area, Spain'
// };
//
// const yetAnotherOwnerStub = {
//   ownerName: 'Labarquilla Basabe Diego'
// };
//
// const lastOwnerStub = {
//   ownerName: 'Marissa sauer',
//   ownerPhoto: 'https://static.wixstatic.com/media/f26672_3e7ee0c491df41c3a7db52e1a0e18c4e~mv2.gif',
//   profileUrl: ['https://www.instagram.com/in/marissa-sauer-947651a/', 'https://www.facebook.com/marissa.sauer.7'],
//   location: 'Bilbao Area, Spain'
// };
//
// const noOwnersStub = [];
// const singleOwnersStub = [ownerStub];
//
// const twoOwnersStub = [anotherOwnerStub, ownerStub];
//
// const moreThanTwoOwnersStub = [
//   anotherOwnerStub,
//   anotherOwnerStub,
//   anotherOwnerStub,
//   anotherOwnerStub,
//   anotherOwnerStub,
//   anotherOwnerStub,
//   anotherOwnerStub
// ];

export type IOwnersSection = {
  owners: Array<IEmployee>
}

function OwnersSection({ owners = [] }: IOwnersSection) {
  const array = owners.map(owner => (
    <Fragment key={owner.name}>
      <div key={owner.name} className={styles.owner}>
        <EmployeeCard
          name={owner.name}
          photoUrl={owner.photoUrl}
          profileUrl={owner.profileUrl}
          location={owner.location}
          email={owner.email}
          isVerified
        />
      </div>
    </Fragment>
  ))

  return (
    <div className={styles.container}>
      <div className={styles.header}>Business Owners ({array.length})</div>
      <div className={styles.owners}>
        {array.length === 0 && <EmployeeCard />}
        {array.length === 1 && <section className={styles.owners}>{array[0]}</section>}
        {array.length === 2 && (
          <section className={styles.owners}>
            {array[0]}
            {array[1]}
          </section>
        )}
        {array.length > 2 && <Carousel slides={array} />}
      </div>
    </div>
  )
}

export default OwnersSection
